/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-empty-function */
<template>
  <!-- <script type="application/javascript" defer src="https://scripts.pay.bka.sh/versions/1.0.000-beta/checkout/bKash-checkout.js"></script> -->
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Bikash Payment</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'dashboard'}">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">BKash payment</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" >
      <div class="container-fluid" style="background: #E2136E; color:white">

      <div class="row">
          <div class="col-md-6">

                 <div class="card" style="background:inherit">
                            <div class="card-header">
                                    Payment Information
                            </div>
                            <div class="card-body">
                                <div class="custom-list">
                                    <form>
                                        <ul >
                                            <li style="color: white"><strong style="color: white" >My Package:</strong> {{ value.package }}</li>
                                            <li  style="color: white"><strong style="color: white" >Monthly Bill</strong> {{ value.monthlyAmount }}</li>
                                            <li  style="color: white"><strong style="color: white" >Available Balance</strong>{{ value.availableBalance }}</li>
                                            <li  style="color: white"><strong style="color: white">Bill due date</strong>{{ value.billDueDate }}</li>
                                            <li  style="color: white"><strong style="color: white">Amount</strong>
                                            <input type="number" maxlength=5 min=1 max=15000 name="amount" id="amount" :value="value.amount" />
                                            </li>
                                        </ul>
                                        <br/>

                                     <router-link :to="{name: 'bkash'}" custom
                                        v-slot="{ href, navigate, isActive }">
                                           <a class="btn btn-lg" style="background:#BD1D5C;border-radius:30px" :href="href" @click="navigate">Submit</a>
                                        <!-- </li> -->
                                      </router-link>
                                        <!-- <a id="bKash_button" class="btn btn-lg" style="background:#BD1D5C;border-radius:30px" href="#">Submit</a> -->
                                        <!-- <button style="background:#BD1D5C;border-radius:30px" class="btn btn-lg" type="submit">Pay with bKash</button> -->
                                        <!-- <div id="bKashFrameWrapper">
                                            <iframe id="bKash-iFrame-821" frameborder="0" src="https://client.pay.bka.sh/checkout" name="bKash_checkout_app" style="display: none; border: none; margin: 0; padding: 0; height: 100%; width: 100%; -webkit-transform: translate3d(0, 0, 0);">
                                            </iframe>
                                        </div> -->
                                    </form>
                                </div>
                            </div>
                            <!-- <div class="card-footer">

                            </div> -->
                        </div>

          </div>
          <div class="col-md-6">
                <div class="card" style="background:inherit">
                      <div class="card-header">
                                   bKash Payment Process
                      </div>
                       <div style="padding:0px" class="card-body bkash-step">
                            <!-- <div class="bkash-step"> -->
                                    <!-- <p class="b">If you have a bKash account then follow the steps below</p> -->
                                    <ul>
                                        <li>Enter Your Payable Amount</li>
                                    </ul>
                                <!-- </div> -->
                       </div>
                </div>
          </div>
      </div>
      </div>

    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
            .bkash-step p {
                letter-spacing: 0.25px;
                margin-bottom: 30px;
            }
            .bkash-step ul li {
                display: block;
                border-radius: 30px;
                background: #C50258;
                margin: 15px 0;
                counter-increment: listNumber;
                letter-spacing: 0.25px;
                font-size: 1rem;
                line-height: 1.75rem;
                padding: 5px;
            }
           .bkash-step ul li::before {
                            content: counter(listNumber);
                            display: inline-block;
                            vertical-align: middle;
                            font-size: 24px;
                            color: #111;
                            background: #fff;
                            border-radius: 50%;
                            height: 40px;
                            width: 40px;
                            text-align: center;
                            margin-right: 10px;
                            line-height: 40px;
                    }
</style>
<script>

import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { CommonAPI } from '@/services/api'
import { Notification } from 'element-ui'
const fileDownload = require('js-file-download')

export default {
  name: 'DataUsage',
  metaInfo: {
    title: 'Ticket History | Dotlines'
  },

  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },

  data: () => ({

    value: {
      package: '10MB',
      monthlyAmount: '2000TK',
      availableBalance: '3000TK',
      billDueDate: '10/02/2022',
      amount: ''
    },
    paymentModel: {
      amount: 0,
      phone: '0190213',
      name: '',
      email: '',
      address: '',
      description: ''
    },
    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0
    },
    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true
  }),

  beforeCreate () {
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://scripts.pay.bka.sh/versions/1.0.000-beta/checkout/bKash-checkout.js'
    )
    plugin.async = true
    document.head.appendChild(plugin)
  },

  // method is called after page load
  mounted: function () {
    const _this = this

    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click')
    // }

    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });

    setTimeout(() => {
      var paymentConfig = {
        // createCheckoutURL: 'createpayment.php',
        createCheckoutURL: 'https://selfcare.carnival.com.bd/bkashgateway/createpayment.php',
        executeCheckoutURL: 'executepayment.php'
      }
      // {amount: $('#amount').html(), intent: 'sale',userid:$('#userid').val(),checkID:$('#checkID').val()};
      var paymentRequest = {
        amount: 1,
        intent: 'sale', // or authorization
        userid: '108331',
        checkID: '059bc9b4b4d7e209a1f9666024799feb'
      }

      var paymentID = null

      bKash.init({
        paymentMode: 'checkout',
        paymentRequest: paymentRequest,
        createRequest: function (request) {
          console.log('Request::', request)
          var responseObject = {
            paymentID: 'XDOJMRO1655706960604',
            createTime: '2022-06-20T06:36:00:635 GMT+0000',
            orgLogo: 'https://s3-ap-southeast-1.amazonaws.com/merchantlogo.pay.bka.sh/merchant-default-logo.png',
            orgName: 'Carnival',
            transactionStatus: 'Initiated',
            amount: 1,
            currency: 'BDT',
            intent: 'sale',
            merchantInvoiceNumber: '108331_qcG0ArHe9'
          }

           setInterval(bKash.create().onSuccess(responseObject), 3000)// 3s delay

        //   _this.is_loading = true
        //   axios({
        //     method: 'post',
        //     url: paymentConfig.createCheckoutURL,
        //     data: JSON.stringify(request),
        //     headers: { 'Content-Type': 'application/json' }
        //   })
        //     .then(function (response) {
        //       // _this.$toaster.success(response.data.message)
        //       _this.is_loading = false
        //       // _this.$router.push({ name: "Users" });
        //       var obj = JSON.parse(response.data)
        //       if (obj && obj.paymentID != null) {
        //         paymentID = obj.paymentID
        //         // bKash.create().onSuccess(obj);
        //         setInterval(bKash.create().onSuccess(obj), 3000)// 3s delay
        //       } else {
        //         bKash.create().onError()// run clean up code
        //       }
        //     })
        //     .catch((errors) => {
        //       bKash.create().onError()// run clean up code
        //       _this.$setErrorsFromResponse(errors.response.data)
        //     })
        //     .finally(() => {
        //       _this.is_loading = false
        //     })
        },
        executeRequestOnAuthorization: function () {
          console.log('Called With auth')
        }
      })
    }, 2000)
  },

  methods: {

    OpenTicket () {
      const _this = this
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          const api_url = '/open-ticket'
          const method = 'POST'
          console.log(this.ticket)
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.is_loading = false
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        } else {
          console.log('Validation failed')
        }
      })
    },

    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss')
    },

    getUsageData () {
    },

    getUsers () {

    },

    apiUsage (query = null) {
      return new Promise((resolve, reject) => {
        axios.get(this.api_url, {
          params: query
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false
          }
          reject(error)
        })
      })
    }

  }
}
</script>
